// non-breaking space
export const nbsp = String.fromCharCode(160);
